










































import { defineComponent } from '@vue/composition-api';
import { useTopicBookmarkDropdownMenu } from '@/modules/teamplan/organisms/ProjectBookmarkDropdownMenu/TopicBookmarkDropdownMenu';

import DropdownMenuBase from '@/modules/teamplan/organisms/DropdownMenu/DropdownMenuBase.vue';
import TopicBookmarkDropdownMenuToggleButton from '@/modules/teamplan/organisms/ProjectBookmarkDropdownMenu/TopicBookmarkDropdownMenuToggleButton.vue';
import DropdownMenuItemBase from '@/modules/teamplan/organisms/DropdownMenu/DropdownMenuItemBase.vue';
import CreateProjectModal from '@/modules/teamplan/organisms/Projects/CreateProjectModal.vue';

export default defineComponent({
  name: 'TopicBookmarkDropdownMenu',
  components: {
    DropdownMenuBase,
    TopicBookmarkDropdownMenuToggleButton,
    DropdownMenuItemBase,
    CreateProjectModal,
  },
  props: {
    topicId: {
      type: Number,
      required: true,
    },
    fit: {
      type: Boolean,
      default: false,
    },
    notAddedLabel: {
      type: String,
      default: 'プロジェクトに保存',
    },
  },
  setup(props) {
    return useTopicBookmarkDropdownMenu(props);
  },
});
